import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "dentainhoa_cookies_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(STORAGE_KEY);
    if (!v) {
      // small delay so it doesn't collide with hero reveal
      const t = setTimeout(() => setVisible(true), 1800);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[70] glass border border-[color:var(--border-subtle)] rounded-2xl p-5 md:p-6 shadow-xl"
    >
      <div className="text-xs uppercase tracking-[0.28em] text-[color:var(--text-secondary)] mb-2">Cookies</div>
      <p className="text-sm text-[color:var(--text-primary)] leading-relaxed mb-4">
        Usamos cookies técnicas necesarias para el funcionamiento de la web y el pago seguro con Stripe. No usamos cookies publicitarias.{" "}
        <Link to="/cookies" className="underline underline-offset-4">Más info</Link>.
      </p>
      <div className="flex gap-2">
        <button
          onClick={() => decide("accepted")}
          data-testid="cookie-accept"
          className="flex-1 rounded-full bg-[color:var(--text-primary)] text-[color:var(--bg-primary)] px-4 py-2.5 text-sm hover:bg-[color:var(--signature-dark)] transition-colors"
        >
          Aceptar
        </button>
        <button
          onClick={() => decide("rejected")}
          data-testid="cookie-reject"
          className="rounded-full border border-[color:var(--border-strong)] text-[color:var(--text-primary)] px-4 py-2.5 text-sm hover:bg-[color:var(--bg-secondary)] transition-colors"
        >
          Solo necesarias
        </button>
      </div>
    </div>
  );
}
